/** https://tc39.es/ecma402/#sec-canonicalizeuvalue */
export function CanonicalizeUValue(_ukey: string, uvalue: string): string {
  return uvalue;
}
